import { Console } from 'console';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { Configuration } from 'config/config';
import { BreadcrumbService } from '../breadcrumb.service';
import { IUser } from '../shared/Domains/IUser';
import {IPettyExpense} from '../shared/Domains/IPettyExpense'
import { IRole } from '../shared/Domains/role';
import { Router } from '@angular/router';
import { LanguageService } from 'app/LanguageService/Language.Service';
import { IBranch } from 'app/shared/Domains/branch';
import { ExportDataComponent } from 'app/members/components/export-data/export-data.component';
@Component({
  selector: 'app-petty-cash',
  templateUrl: './petty-cash.component.html',
  styleUrls: ['./petty-cash.component.css']
})
export class PettyCashComponent implements OnInit {
  @ViewChild("searchProduct", { static: false }) searchProductInput: ElementRef;
  user: IUser;
  loading: boolean;
  role: IRole;
  amount: number;
  selectedUser: string;
  purchasedItem: string;
  billType: string;
  description: string;
  paymentMode: string;
  expenseType: string;
  paymentOptions = [];
  pettyExpenseDialogVisibility: boolean;
  pettyExpenses: IPettyExpense[];
  filteredPettyExpenses: IPettyExpense[];
  Users: any[];
  userOptions: any[];
  branch: IBranch;
  usersOptions: any[];
  isDeducted: boolean = false;
  isReturned: boolean = false;
  from: any;
  to: any;
  accountHolderOptions: any[] = [];
  optionValue: string;
  accountHolders: any;
  constructor(
    private LanguageService: LanguageService,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    public config: Configuration,
    private router: Router,
    private appServiceManager: AppServiceManager,
    public confirmationService: ConfirmationService,
    private exportDataComponent: ExportDataComponent,
  ) {
    this.breadcrumbService.setItems([
      { label: 'Petty Cash' }
    ]);
  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("PettyCashComponent", label);
  }
  ngOnInit(): void {
    this.user = AuthService.getLoggedInUser();
    this.amount = 0;
    this.expenseType = "";
    this.purchasedItem = "";
    this.billType = "";
    this.description = "";
    var date = new Date();
    this.from = new Date(date.getFullYear(), date.getMonth(), 1);
    this.to = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    this.from.setHours(0, 0, 0, 0);
    this.to.setHours(23, 59, 59, 999);

    this.paymentOptions = [
      { label: 'Cash - Reception', value: 'Cash-Reception' },
    ];
    this.paymentMode = "Cash-Reception";
    this.getUserByID();
    this.getBranch();
    this.getUserPettyExpenses();
    this.role = AuthService.getLoggedInRole();
    if (this.user.hasPettyCashAccount == null || this.user.hasPettyCashAccount == undefined || !this.user.hasPettyCashAccount) {
      this.router.navigate(['/404']);
    }
    this.getAllUsers();
    this.userOptions = [{ label: "Select Borrower", value: null }];
    this.usersOptions = [{ label: "Select Name", value: null }];
    this.getPettyAccountHolders();
  }


  getUserByID() {
    this.appServiceManager.get("users/" + this.user._id).subscribe(res => {
      if (res) {
        this.user = res;
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  getBranch() {
    this.branch = AuthService.getLoggedInCurrentBranch();
    if(this.branch){
      if (Array.isArray(this.branch.payments)) {
        this.branch.payments.forEach(payment => {
          const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
          if (!existingBank) {
            this.paymentOptions.push({
              label: `${payment.type} - ${payment.name}`,
              value: `${payment.type}-${payment.name}`
            });
          }
        });
      }
    }
    if(!this.branch){
      this.appServiceManager.get('branches/' + this.user.branch).subscribe((res) => {
        if (res) {
          res.payments.forEach(payment => {
            const existingBank = this.paymentOptions.find(option => option.value === `${payment.type}-${payment.name}`);
            if (!existingBank) {
              this.paymentOptions.push({
                label: `${payment.type} - ${payment.name}`,
                value: `${payment.type}-${payment.name}`
              });
            }
          });
        } else {
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
        (error) => {
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        });
    }
  }
  onChangeHolderValue() {
    if (this.optionValue) {
      this.appServiceManager.get(`users/${this.optionValue}`).subscribe(
        (res) => {
          if (res) {
            this.user.pettyCash = res.pettyCash;
            this.filteredPettyExpenses = this.pettyExpenses.filter(expense => expense.user === this.optionValue);
            this.getUserPettyExpenses();
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
        },
        (error) => {
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        }
      );
    } else {
      this.filteredPettyExpenses = this.pettyExpenses;
      this.getUserPettyExpenses();
    }
  }

  getUserPettyExpenses() {
    if (this.from <= this.to) {
      this.loading = true;
      this.optionValue = this.optionValue ? this.optionValue : this.user._id;
      this.user._id = this.optionValue
      const apiUrl = `pettyExpense/${this.user._id}/?dateFrom=${this.from}&dateTo=${this.to}`;
      this.appServiceManager.get(apiUrl).subscribe(res => {
        if (res) {
          this.pettyExpenses = res.response;
          this.filteredPettyExpenses = this.pettyExpenses; // Initialize filteredPettyExpenses
          this.loading = false;
        } else {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
        (error) => {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        });
    } else {
      this.loading = false;
      this.messageService.clear();
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'From Date is greater than To Date' });
    }
  }

  getPettyAccountHolders() {
    this.accountHolderOptions = [];
    this.loading = true;
    this.appServiceManager.get('users/branch/' + this.user.branch).subscribe(
      (res) => {
        if (res.length > 0) {
          this.accountHolders = res.filter(user => user.hasPettyCashAccount);
          this.accountHolderOptions = this.accountHolders.map(user => ({
            label: `${user.name} (${user.role})`,
            value: user._id
          }));
          this.loading = false;
        } else {
          this.accountHolderOptions = [];
          this.messageService.clear();
          this.messageService.add({
            severity: "info",
            summary: "Info Message",
            detail: "No Record Found",
          });
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({
          severity: "error",
          summary: "Error Message",
          detail: error,
        });
      }
    );
  }

  showAddExpensePopup() {
    this.pettyExpenseDialogVisibility = true;
    this.amount = 0;
    this.expenseType = "";
    this.purchasedItem = "";
    this.billType = "";
    this.description = "";
  }

  onPaymentModeChange(value: string) {
    this.paymentMode = value;
  }

  dropdownChange(e) {
    console.log(e);
    this.selectedUser = e.value;
  }

  addPettyExpense() {
    if (this.amount > this.user.pettyCash) {
      this.messageService.clear();
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Not enough amount in balance.' });
      return;
    }
    if (this.amount <= 0 || this.expenseType.length <= 0) {
      this.messageService.clear();
      this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Add proper amount or expanse type.' });
      return;
    }
    // this.isReturned=true;
    const expense = {
      amount: this.amount,
      type: this.expenseType,
      borrowerName: undefined,
      accountHolderName: undefined,
      borrowerId: undefined,
      accountHolderId: undefined,
      isDeducted: false,
      // isReturned:this.isReturned,
      purchasedItem: this.purchasedItem,
      billType: this.billType,
      description: this.description,
      user: this.user._id,
      branch: this.user.branch,
      company: this.user.company,
      createdBy: this.user._id,
      modeOfPayment: this.paymentMode,
      scope: 'Petty Cash',
      initiatedFrom: 'Add Petty Cash',
      activityBy: this.user.name,
    }

    if (this.expenseType === "Lending") {
      expense.borrowerName = this.Users.filter(u => u._id === this.selectedUser)[0].name;
      expense.borrowerId = this.selectedUser;
    }
    if (this.expenseType === "Account Deducted") {
      expense.accountHolderName = this.Users.filter(u => u._id === this.selectedUser)[0].name;
      expense.accountHolderId = this.selectedUser;
    }
    this.appServiceManager.post("pettyExpense", expense).subscribe(res => {
      if (res) {
        this.pettyExpenseDialogVisibility = false;
        this.getUserByID();
        this.getUserPettyExpenses();
        this.amount = 0;
        this.expenseType = "";
        this.purchasedItem = "";
        this.billType = "";
        this.description = "";
        this.messageService.clear();
        this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Expenses added Successfully' });
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
      }
    },
      (error) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  getDetailOfExpance(expance) {
    if(expance.type === "Rent" && expance.purchasedItem !== undefined) {
      return expance.type;
    }
    else if(expance.type === "Salary" && expance.purchasedItem !== undefined) {
      return "Employee Name: " + expance.employee;
    }
    else if(expance.type === "Purchasing" && expance.purchasedItem !== undefined) {
      return "Items Purchased: " + expance.purchasedItem;
    }
    else if(expance.type === "Lending" && expance.borrowerName !== undefined) {
      return "Amount Lend: " + expance.borrowerName;
    }
    else if(expance.type === "Account Deducted" && expance.accountHolderName !== undefined) {
      return "Account Holder: " + expance.accountHolderName;
    }
    else if(expance.type === "Bills" && expance.billType !== undefined) {
      return "Bills Paid: " + expance.billType;
    }

    else {
      return "";
    }
  }
  getAllUsers() {
    this.Users = [];
    this.loading = true;
    this.appServiceManager.get('users/company/' + this.user.company + '/branch/' + this.user.branch).subscribe(
      (res) => {
        if (res.length > 0) {
          this.Users = res;
          this.setUserData(this.Users);

        } else {
          this.Users = [];
          this.messageService.clear();
          this.messageService.add({
            severity: "info",
            summary: "Info Message",
            detail: "No Record Found",
          });
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({
          severity: "error",
          summary: "Error Message",
          detail: error,
        });
      }
    );
  }
  updatePettyExpense(id) {
    const expense = {};
    this.appServiceManager.post("pettyexpense/"+id+"/lendingReturned", expense).subscribe(res => {
        if (res) {

            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Expenses Updated Successfully' });
        } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
    },
        (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
        });
}

  setUserData(Users) {

    this.Users.forEach((Users) => {
        this.userOptions.push({
            label: Users.name,
            value: Users._id,
        });
        this.usersOptions.push({
          label: Users.name,
          value: Users._id,
      });
    });
}
ExportData(expenses, name) {
  if (expenses && expenses.length > 0) {
    this.confirmationService.confirm({
      message: "Are you sure you want to Export?",
      accept: () => {
        const transformedData = expenses.map(pe => {
        const type_details = this.getDetailOfExpance(pe);

          return {
            Amount: parseFloat(pe?.amount || 0),
            ExpenseType: pe?.type,
            Date: new Date(pe?.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }),
            Details: type_details,
            CreatedOn: new Date(pe?.createdDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }),
            Comments: pe?.description,
          };
        });

        const totalRecords = expenses.length;
        const totalAmount = transformedData.reduce((acc, curr) => acc + parseFloat(curr.Amount), 0);

        const summary = {
          Total_Rows: totalRecords,
          Total_Amount: totalAmount, 
        };
        this.exportDataComponent.ExportDataReports(transformedData, summary, name);
      }
    });
  } 
}

closePettyCashDialog() {
  this.pettyExpenseDialogVisibility = !this.pettyExpenseDialogVisibility;
}
}
